var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 97,
    viewBox: "0 0 71 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M43.6789 80.9221L27.4319 85.5865L0 14.3686H19.1581L32.9415 50.682L39.4841 68.1342L42.7554 76.8604L43.6789 80.9221Z",
    fill: "url(#paint0_linear_25_3715)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.4824 27.0158V42.4489H22.0476V26.7967C21.5155 26.7967 20.9833 26.8906 20.4824 27.0158Z",
    fill: "url(#paint1_linear_25_3715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.1934 32.6506V42.4802H20.4821V27.0158C18.009 27.7045 16.1934 29.9584 16.1934 32.6506Z",
    fill: "url(#paint2_linear_25_3715)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.7781 22.007C28.2459 22.007 27.7138 22.101 27.2129 22.2262V42.4802H28.7781V22.007Z",
    fill: "url(#paint3_linear_25_3715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M22.9238 27.861V42.4802H27.2125V22.2262C24.7395 22.9149 22.9238 25.1688 22.9238 27.861Z",
    fill: "url(#paint4_linear_25_3715)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.9121 15.9966V42.4802H35.4773V15.7775C34.9139 15.7775 34.413 15.8714 33.9121 15.9966Z",
    fill: "url(#paint5_linear_25_3715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M29.623 21.6314V42.4802H33.9118V15.9966C31.4387 16.6853 29.623 18.9392 29.623 21.6314Z",
    fill: "url(#paint6_linear_25_3715)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M70.8822 40.5706C70.8196 37.3149 70.1935 34.0906 69.3796 30.8975C68.9413 29.2384 68.4091 27.5793 67.877 25.7949C67.5326 28.3306 67.4074 30.7723 66.8752 33.0888C66.8752 33.1514 66.8439 33.2141 66.8439 33.2767C65.31 39.9132 61.2091 44.9845 56.263 49.3985C51.943 53.2489 47.4038 56.9116 43.1151 60.762C37.8873 65.4577 33.6612 70.8734 31.3133 77.6038C31.282 77.729 31.1255 77.823 30.9064 78.0421C31.0942 75.1934 31.7829 72.6264 32.8786 70.1847C35.1638 65.1133 38.7638 61.0124 42.5829 57.0681C46.2143 53.3115 49.9708 49.6489 53.4769 45.7672C55.2613 43.795 56.8265 41.5724 58.2352 39.2871C62.1796 32.8697 62.5865 26.0766 59.9882 19.0644C58.4543 14.9009 56.263 11.1444 53.7273 7.6696C51.7552 5.00872 49.5952 2.47305 47.4038 0C48.4056 4.63306 49.5952 9.29743 50.4091 14.0244C52.3813 25.7949 49.3447 36.1254 41.1742 44.9219C38.7325 47.5515 36.3847 50.2437 33.9742 52.9046C26.0855 61.6385 23.9255 71.8751 26.1794 83.176C27.0559 87.6213 27.682 91.6908 29.4664 96.3865C29.4977 96.4804 29.5603 96.6056 29.6855 96.95C30.4994 94.9465 31.3759 92.4108 32.2525 90.3134C32.3777 90.0317 32.4716 89.7813 32.5968 89.4995C36.3221 81.1725 42.2073 74.5673 49.376 69.0577C53.2578 66.0838 57.2335 63.2038 61.0839 60.1672C65.8422 56.3794 69.5048 51.7776 70.5379 45.5793C70.8509 43.8889 70.9448 42.2298 70.8822 40.5706Z",
    fill: "url(#paint7_linear_25_3715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M64.0269 56.0037C63.9643 53.6559 63.4635 51.3394 62.7748 49.0541C62.3991 47.8646 61.9609 46.675 61.5539 45.3915C61.2722 47.2385 61.1469 48.9602 60.7087 50.6507C60.7087 50.682 60.6774 50.7446 60.6774 50.7759C59.3939 55.5655 56.013 59.1968 51.8808 62.3898C48.2808 65.1759 44.5556 67.7742 40.9555 70.5916C36.6355 73.9725 33.0981 77.8543 31.1572 82.7065C31.1259 82.8004 31.0007 82.863 30.8442 83.0195C31.0007 80.9534 31.5642 79.1377 32.472 77.3847C34.3503 73.7221 37.3555 70.7794 40.5173 67.9307C43.5225 65.2072 46.653 62.5777 49.5643 59.7916C51.0669 58.3829 52.3504 56.755 53.5086 55.1272C56.7643 50.5254 57.1087 45.6106 54.98 40.5706C53.6965 37.5654 51.8808 34.8732 49.7834 32.3688C48.1556 30.428 46.3712 28.6123 44.5243 26.8279C45.3695 30.1775 46.3399 33.5271 46.9973 36.908C48.6251 45.3915 46.1208 52.842 39.3277 59.1655C37.2929 61.0437 35.352 62.9846 33.3485 64.9255C26.7746 71.2177 24.9902 78.5743 26.8685 86.7134C27.6198 89.9065 28.1207 92.8491 29.6233 96.23C29.6546 96.2926 29.6859 96.3865 29.8111 96.6369C30.4685 95.1969 31.2198 93.3813 31.9398 91.8787C32.0338 91.6908 32.1277 91.4717 32.2216 91.2839C35.3207 85.2734 40.2042 80.5464 46.1521 76.5708C49.3764 74.4108 52.6947 72.3447 55.8565 70.1534C59.8008 67.4299 62.8374 64.1116 63.7139 59.635C63.9956 58.3829 64.0583 57.1933 64.0269 56.0037Z",
    fill: "url(#paint8_linear_25_3715)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M6.01998 46.9254C5.20606 47.5202 4.57997 48.3967 4.0791 49.4611C12.2809 50.2124 16.2252 55.6281 18.9487 62.3898C19.794 64.4559 20.42 66.6472 21.2653 69.1516C21.4844 67.7429 21.8287 66.3655 22.2044 65.082C21.5783 63.1724 21.0461 61.4507 20.3887 59.7916C17.7592 53.1863 13.9087 47.8645 6.01998 46.9254Z",
    fill: "url(#paint9_linear_25_3715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M35.5719 43.4506C29.2484 43.4506 22.9562 43.4819 16.6327 43.4506C15.4118 43.4506 14.4727 43.7637 13.6901 44.7654C13.4083 45.1098 12.7509 45.2037 12.25 45.2976C10.6848 45.6106 9.08829 45.7045 7.58568 46.1741C7.0222 46.3619 6.52133 46.6124 6.05176 46.9567C13.9405 47.8646 17.7596 53.2176 20.4205 59.8229C21.0779 61.482 21.6101 63.2038 22.2362 65.1133C23.1127 62.2959 24.3336 59.6977 25.8049 57.2872C28.4032 52.1533 32.1597 47.8019 36.1667 43.5132C35.9475 43.4506 35.7597 43.4506 35.5719 43.4506Z",
    fill: "url(#paint10_linear_25_3715)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M58.1416 67.7116C58.079 66.0212 57.672 64.362 57.1085 62.7029C56.7955 61.8264 56.4511 60.9811 56.0755 60.0733C55.8564 61.3881 55.7311 62.6403 55.3868 63.8612C55.3868 63.8925 55.3555 63.9238 55.3555 63.9551C54.2911 67.3986 51.4737 70.0281 48.0615 72.3134C45.0876 74.3169 41.9572 76.1951 38.9832 78.1986C35.3832 80.6404 32.4719 83.4265 30.8441 86.9326C30.8128 86.9952 30.7189 87.0265 30.5623 87.183C30.6876 85.7117 31.1571 84.3969 31.9084 83.1134C33.4737 80.4838 35.9467 78.3551 38.5763 76.3203C41.0806 74.3795 43.6476 72.4699 46.0894 70.4664C47.3415 69.4334 48.4059 68.2751 49.3763 67.1168C52.0998 63.7985 52.3816 60.2611 50.5972 56.6298C49.5329 54.4698 48.0302 52.5289 46.2772 50.7133C44.9311 49.3046 43.4285 47.9898 41.9259 46.7063C42.6146 49.1167 43.4285 51.5272 43.992 53.9689C45.3381 60.0733 43.272 65.4264 37.6371 69.9968C35.9467 71.3429 34.3502 72.7516 32.691 74.129C27.2441 78.6369 25.7727 83.9586 27.338 89.8126C27.9641 92.1291 28.371 94.2265 29.6232 96.6683C29.6545 96.7309 29.6858 96.7935 29.7797 96.95C30.3432 95.917 30.938 94.6022 31.5328 93.5065C31.6267 93.35 31.6893 93.2248 31.7832 93.0995C34.3502 88.7795 38.4198 85.3673 43.3346 82.5186C46.0267 80.9847 48.7502 79.4821 51.3798 77.9169C54.6668 75.9447 57.1711 73.5655 57.8911 70.3412C58.1103 69.4334 58.1729 68.5881 58.1416 67.7116Z",
    fill: "url(#paint11_linear_25_3715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M53.2582 75.9134C53.2269 74.6925 52.8512 73.5029 52.3817 72.3134C52.1312 71.6873 51.8182 71.0612 51.5365 70.4038C51.3486 71.3429 51.2547 72.2508 50.973 73.1273C50.973 73.1586 50.9417 73.1586 50.9417 73.1899C50.0651 75.663 47.7173 77.5725 44.8999 79.2004C42.4268 80.6404 39.8286 81.9865 37.3868 83.4578C34.4129 85.2108 31.9711 87.2143 30.6251 89.75C30.5937 89.7813 30.5311 89.8126 30.4059 89.9065C30.4998 88.8422 30.9068 87.903 31.5329 86.9639C32.8477 85.0543 34.8825 83.5517 37.0738 82.0804C39.1399 80.6717 41.2999 79.3256 43.3034 77.8543C44.3364 77.1343 45.2129 76.289 46.0269 75.4438C48.2808 73.0647 48.4999 70.529 47.0286 67.8994C46.1521 66.3342 44.8999 64.9568 43.4599 63.642C42.3329 62.6403 41.1121 61.7012 39.8286 60.762C40.392 62.4838 41.0807 64.2368 41.5503 65.9899C42.6773 70.3725 40.9555 74.2543 36.2912 77.5099C34.8825 78.4804 33.5364 79.4821 32.1903 80.4839C27.6824 83.7395 26.4302 87.5587 27.745 91.7848C28.2459 93.4439 28.5903 94.9778 29.6233 96.7309C29.6546 96.7622 29.6859 96.8248 29.7485 96.95C30.2181 96.1987 30.719 95.2596 31.2198 94.477C31.2824 94.383 31.3451 94.2578 31.4077 94.1639C33.5364 91.0648 36.9173 88.5917 41.0181 86.5256C43.2408 85.3987 45.526 84.3343 47.7173 83.2073C50.4408 81.7986 52.5382 80.0769 53.133 77.7604C53.2269 77.1343 53.2895 76.5082 53.2582 75.9134Z",
    fill: "url(#paint12_linear_25_3715)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_3715",
    x1: 22.4692,
    y1: 15.7775,
    x2: 22.4692,
    y2: 85.5865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#69A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1DEF1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_25_3715",
    x1: 21.265,
    y1: 26.7967,
    x2: 21.265,
    y2: 42.4489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5285CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4C5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_25_3715",
    x1: 18.3377,
    y1: 27.0158,
    x2: 18.3377,
    y2: 42.4802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184B98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_25_3715",
    x1: 27.9955,
    y1: 22.007,
    x2: 27.9955,
    y2: 42.4802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5285CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4C5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_25_3715",
    x1: 25.0682,
    y1: 22.2262,
    x2: 25.0682,
    y2: 42.4802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184B98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_25_3715",
    x1: 34.6947,
    y1: 15.7775,
    x2: 34.6947,
    y2: 42.4802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5285CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4C5F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_25_3715",
    x1: 31.7674,
    y1: 15.9966,
    x2: 31.7674,
    y2: 42.4802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#195BBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#184B98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_25_3715",
    x1: 53.6937,
    y1: -8.07347e-7,
    x2: 27.9815,
    y2: 96.7988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3174E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#193E65"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_25_3715",
    x1: 45.0992,
    y1: 26.8279,
    x2: 45.0992,
    y2: 96.6369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79AFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0045B7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_25_3715",
    x1: 4.28613,
    y1: 45.6265,
    x2: 22.4359,
    y2: 71.0866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#477CC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8D5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_25_3715",
    x1: 21.1092,
    y1: 43.4506,
    x2: 21.1092,
    y2: 65.1133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6FD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#134389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_25_3715",
    x1: 42.4486,
    y1: 46.7063,
    x2: 42.4486,
    y2: 96.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF7900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_25_3715",
    x1: 40.2587,
    y1: 60.762,
    x2: 40.2587,
    y2: 96.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEDCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB9200"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.135267554dbb86ebef0c15dad2336ce1.svg";
export { ForwardRef as ReactComponent };